<h4 mat-dialog-title>Acquisition: {{ acquisition.label }}</h4>
<button mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content>
  <ng-container *ngIf="!error; else errorState">
    <container-notes
      [container]="acquisition"
      [notes]="acquisition.notes">
    </container-notes>
  </ng-container>
  <ng-template #errorState>
    <div class="info-message">
      <div class="fab">
        <mat-icon>error_outline</mat-icon>
      </div>
      <ng-container [ngSwitch]="$any(error).status">
        <p *ngSwitchCase="404">{{ acquisition.label }} does not exist.</p>
        <ng-container *ngSwitchDefault>
          <p>{{ acquisition.label }} notes could not be loaded.</p>
          <button mat-flat-button (click)="getAcquisition()" color="primary">Try Again</button>
        </ng-container>
      </ng-container>
    </div>
  </ng-template>

</div>
<div mat-dialog-actions align="end">
  <button mat-stroked-button (click)="close()" test-id="acquisition-notes-dialog-close">
    Close
  </button>
</div>
